import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import useStyles from '../styles';
import OTPForm from './OTPForm';
import useApi from '../../../services/api/useApi';
import WalletAlpha from '../../../services/walletAlpha/walletAlpha';
import { useAppSelector } from '../../../store/hooks';
import { useOnMessage } from '../../../utils/hooks';
import { setChannel } from '../loginSlice';
import useAuthToken from '../useAuthToken';
import useAuthUser from '../useAuthUser';
import useStoreWhereLoggedIn from '../useStoreWhereLoggedIn';
import setInitializeData from '../../../utils/initializeData';

function OTPFormContainer() {
  const classes = useStyles();
  const api = useApi();
  const { email } = useAppSelector((state) => state.user);
  const { channel, type, source } = useAppSelector((state) => state.login);
  const { cartHash, cartId, storeId } = useAppSelector((state) => state.cart);
  const dispatch = useDispatch();
  const { setToken } = useAuthToken();
  const { storeUser } = useAuthUser();
  const { setStore } = useStoreWhereLoggedIn();

  useOnMessage(
    WalletAlpha.messages.NUVEM_INITIALIZE,
    async (messageData: WalletAlphaMessageData<InitializeData>) => {
      setInitializeData(dispatch, messageData);
    }
  );

  useOnMessage(
    WalletAlpha.messages.NUVEM_CHANGE_OTP_CHANNEL,
    async (messageData: WalletAlphaMessageData<InitializeData>) => {
      dispatch(setChannel(messageData.data.channel));
    }
  );

  useEffect(() => {
    WalletAlpha.postMessage(
      WalletAlpha.messages.NUVEM_READY,
      {
        data: WalletAlpha.messages.NUVEM_READY,
      },
      '*'
    );
  }, []);

  const onOTPCompleted = async (otp: string) => {
    WalletAlpha.postMessage(WalletAlpha.messages.NUVEM_SEND_OTP_RECEIVED, { email }, '*');

    try {
      const data = await api.login({
        otp,
        email,
        cartId,
        cartHash,
        storeId,
        channel,
        type,
        source,
        customer_data: true,
      });

      setStore(storeId);

      setToken(data);

      api.addAuthorizationHeader(data.accessToken);

      storeUser(data.user);

      WalletAlpha.postMessage(
        WalletAlpha.messages.NUVEM_LOGIN_SUCCESS,
        {
          user: data.user,
        },
        '*'
      );
    } catch (error: unknown) {
      WalletAlpha.postMessage(WalletAlpha.messages.NUVEM_LOGIN_FAILURE, undefined, '*');
    }
  };

  return (
    <div className={classes.container} data-testid="otpFormContainer">
      <OTPForm onOTPCompleted={onOTPCompleted} />
    </div>
  );
}

export default OTPFormContainer;
